import {GET_FORM_CASH_MOVEMENT_NOSEAL} from 'shared/constants/ActionTypes';

const initialState = {
  form: {
    sealNoList: [
      {
        sealNo: '',
      },
    ],
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FORM_CASH_MOVEMENT_NOSEAL:
      return {
        ...state,
        form: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
